/**
 * external libs
 */
import React, {useContext, useEffect, useRef, useState} from 'react'
import {BlobServiceClient} from "@azure/storage-blob";
import {Tooltip, Progress} from "antd";
import prettyBytes from 'pretty-bytes';
import EditebleItem from './components/EditebleItem'
/**
 * styles
 */
import {AlertContext} from "../../../../../../pages/context/alert.context";
import DateTime from "../../../../../../utils/DateTime";
import ResultModel from "../../../../../../model/medicalCard/result.model";
import FieldItem from "../../../../../Form/components/FieldItem";
import LinkEdit from "../../../WidgetImage/components/Editable/components/LinkEdit";
import TakePicture from "../../../../../Modal/TakePicture";
import FileItem from "../File";
import styles from './index.module.scss'
import {useTranslation} from "react-i18next";
import BlobService from "../../../../../../services/blob.service";

export default function EditableFileWidget({
                                               onEdit,
                                               field,
                                               widget,
                                               originalWidget,
                                               canBeLink,
                                               showDescription,
                                               extensions,
                                               files,
                                               result
                                           }) {
    const {i18n} = useTranslation();
    const {t} = useTranslation()
    const [clipBoardFile, setClipBoardFile] = useState(null);
    const [openTakePicture, setOpenTakePicture] = useState(false);
    const [openChangeLink, setOpenChangeLink] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const haveFile = useRef(false)
    const {setAlertSuccess, setAlertError} = useContext(AlertContext)
    const [resultData, setResultData] = useState(result)

    const uploadFile = async (file, index = 0) => {
        const {upload_url, upload_multipart} = widget['x-path'];
        const regex = /https?:\/\/(.+)/;
        const match = process.env.REACT_APP_API_BASE_URL.match(regex);
        const extensionFile = file.name.split('.')[file.name.split('.').length - 1]
        const baseUrlWithoutProtocol = match[1]
        const azureContainerImage = upload_url.split('/')[upload_url.split('/').length - 2]
        let sasToken = null


        let currentUrl = upload_url;
        currentUrl = currentUrl.replace("{result.id}", result.id.toUpperCase())
        currentUrl = currentUrl.replace("{token}", result.token || new ResultModel().token)
        currentUrl = currentUrl.replace("{ext}", extensionFile)
        currentUrl = currentUrl.replace("{azure_blob_storage}", process.env.REACT_APP_AZURE_BLOB_STORAGE)
        currentUrl = currentUrl.replace("{cor_blob_storage}", baseUrlWithoutProtocol)

        if (upload_url.includes("{azure_blob_storage}")) {
            if (azureContainerImage === "image") {
                sasToken = process.env.REACT_APP_AZURE_STORAGE_SAS_TOKEN_IMAGE_CONTAINER;
            }

            if (azureContainerImage === "svs") {
                sasToken = process.env.REACT_APP_AZURE_STORAGE_SAS_TOKEN_SVS_CONTAINER
            }

            const blobServiceClient = new BlobServiceClient(`https://${process.env.REACT_APP_AZURE_BLOB_STORAGE}?${sasToken}`);
            const containerClient = blobServiceClient.getContainerClient(azureContainerImage);

            const uploadOptions = {
                onProgress: (progress) => {
                    setUploadedFiles(prevUploadedFiles => {
                        const copyPrevUploadedFiles = JSON.parse(JSON.stringify(prevUploadedFiles));

                        copyPrevUploadedFiles[index].progress = Math.round(progress.loadedBytes / file.size * 100);

                        return copyPrevUploadedFiles
                    })
                }
            };
            if (extensionFile === "svg") {
                uploadOptions.blobHTTPHeaders = {
                    blobContentType: "image/svg+xml"
                }
            }

            if (["png", "jpg", "jpeg"].includes(extensionFile)) {
                uploadOptions.blobHTTPHeaders = {
                    blobContentType: `image/${extensionFile}`
                }
            }

            if (extensionFile === "pdf") {
                uploadOptions.blobHTTPHeaders = {
                    blobContentType: "application/pdf"
                }
            }

            const blockBlobClient = containerClient.getBlockBlobClient(currentUrl.split('/')[currentUrl.split('/').length - 1]);
            await blockBlobClient.uploadData(file, uploadOptions)
            setAlertSuccess('File uploaded!');

            return {
                name: file.name,
                url: currentUrl,
                created_at: DateTime.dateToBackendFormat(new Date(resultData.measures?.[field]?.created_at || new Date())),
                modified_at: DateTime.dateToBackendFormat(new Date())
            }
        }

        if (upload_url.includes("{cor_blob_storage}")) {
            try {
                if (!upload_multipart || !upload_multipart.key) {
                    return null
                }

                let uploadMultipartKey = upload_multipart.key;
                uploadMultipartKey = uploadMultipartKey.replace("{result.id}", result.id.toUpperCase())
                uploadMultipartKey = uploadMultipartKey.replace("{token}", result.token || new ResultModel().token)
                uploadMultipartKey = uploadMultipartKey.replace("{ext}", extensionFile)

                const container = "medical";
                const formData = new FormData();
                formData.append(uploadMultipartKey, file);

                await BlobService.uploadFile(
                    currentUrl,
                    formData,
                    {},
                    {
                        onUploadProgress: progressEvent => {
                            setUploadedFiles(prevUploadedFiles => {
                                const copyPrevUploadedFiles = JSON.parse(JSON.stringify(prevUploadedFiles));
                                copyPrevUploadedFiles[index].progress = Math.round(progressEvent?.progress.toFixed(3) * 100);

                                return copyPrevUploadedFiles
                            })
                        }
                    }
                )

                setAlertSuccess('File uploaded!');

                return {
                    name: file.name,
                    url: `${process.env.REACT_APP_API_BASE_URL}/blob?path=${container}/${uploadMultipartKey}`,
                    created_at: DateTime.dateToBackendFormat(new Date(resultData.measures?.[field]?.created_at || new Date())),
                    modified_at: DateTime.dateToBackendFormat(new Date())
                }
            } catch (e) {
                setAlertError(e.message || "Something went wrong")
                return null
            }
        }
    }

    const onFileChange = async (e) => {
        const files = e.target.files;

        setUploadedFiles(new Array(files.length).fill(null).map((_, index) => {
            const file = files[index];

            return {
                name: file.name,
                size: file.size,
                progress: 0,
            }
        }))

        Promise.all(new Array(files.length).fill(null).map((_, index) => uploadFile(files[index], index)))
            .then(uploadedFilesRequest => {
                let currentFiles = resultData.measures?.[field]
                currentFiles = Array.isArray(currentFiles) ? currentFiles : [currentFiles]
                currentFiles = currentFiles.filter(file => file);

                const uploadedFiles = uploadedFilesRequest.filter(file => file);

                onEdit({
                    ...resultData,
                    is_modified: true,
                    measures: {
                        ...resultData.measures,
                        [field]: widget.type.includes('array') ? [...(currentFiles || []), ...uploadedFiles] : uploadedFiles[0],
                    }
                })
            })
            .catch(e => {
                setAlertError('File not uploaded!');
            })
            .finally(() => setUploadedFiles([]))
    }

    const onLinkChange = (currentUrl) => {
        const file = {
            name: "file",
            url: currentUrl,
        }
        const currentFiles = resultData.measures?.[field]

        onEdit({
            ...resultData,
            is_modified: true,
            measures: {
                ...resultData.measures,
                [field]: widget.type.includes('array') ? [...(currentFiles || []), file] : file,
            }
        })
    }

    const onPhotoChange = async (currentFile) => {
        setUploadedFiles([{
            name: currentFile.name,
            size: currentFile.size,
            progress: 0,
        }])

        uploadFile(currentFile)
            .then(file => {
                if (!file) {
                    return null;
                }

                const currentFiles = resultData.measures?.[field]

                onEdit({
                    ...resultData,
                    is_modified: true,
                    measures: {
                        ...resultData.measures,
                        [field]: widget.type.includes('array') ? [...(currentFiles || []), file] : file,
                    }
                })
            })
            .catch(e => {
                setAlertError('File not uploaded!');
            })
            .finally(() => setUploadedFiles([]))

    }

    const uploadClipBoardFile = async () => {
        setUploadedFiles([{
            name: clipBoardFile.name,
            size: clipBoardFile.size,
            progress: 0,
        }])
        uploadFile(clipBoardFile)
            .then( file => {
                if (!file) {
                    return null
                }

                const currentFiles = resultData.measures?.[field]

                onEdit({
                    ...resultData,
                    is_modified: true,
                    measures: {
                        ...resultData.measures,
                        [field]: widget.type.includes('array') ? [...(currentFiles || []), file] : file,
                    }
                })
            })
            .catch(e => {
                setAlertError('File not uploaded!');
            })
            .finally(() => setUploadedFiles([]))
    }

    const deleteFiles = (index) => {
        const currentFiles = Array.isArray(resultData.measures?.[field]) ? resultData.measures?.[field] : [resultData.measures?.[field]]
        const newFiles = currentFiles.filter((_, currentIndex) => currentIndex !== index);

        onEdit({
            ...resultData,
            is_modified: true,
            measures: {
                ...resultData.measures,
                [field]: newFiles.length ? newFiles : null,
            }
        })
    }

    const getImageFromClipBoard = async () => {
        try {
            let file = null;
            const clipboardItems = await navigator.clipboard.read();
            const [clipBoardItem] = clipboardItems;

            for (const type of clipBoardItem.types) {
                if (type.startsWith('image/')) {
                    const blob = await clipBoardItem.getType(type);
                    const [_, ext] = type.split('/')
                    const generatedFileName = `pasted-image-${Date.now()}.${ext}`;
                    const currentFile = new File([blob], generatedFileName, {
                        type: blob.type,
                        lastModified: new Date().getTime(),
                        size: blob.size,
                    });

                    file = currentFile
                    setClipBoardFile(currentFile)
                }
            }


            if (!file) {
                setClipBoardFile(null)
            }
        } catch (err) {
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            getImageFromClipBoard()
        }, 1000)


        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        setResultData(result)
    }, [result])

    return (
        <div>
            <FieldItem label={widget.description || ""}
                       requiredColor={files?.length ? "#1084FF" : "red"}
                       required={!widget.type.includes("null")}
                       stylesWrapper={{marginBottom: 10, position: "relative", zIndex: 11}}>
                <div style={{display: "flex"}}>
                    {widget['x-path'].upload_url && (
                        <label htmlFor={`file_${result.id}`}>
                            <Tooltip placement="top"
                                     title={t(`${widget.type.includes('array') ? "Add files" : "Add file"}`)}>
                                <svg width="42" height="42" viewBox="0 0 42 42" fill="none"
                                     xmlns="http://www.w3.org/2000/svg"
                                     style={{cursor: "pointer"}}>
                                    <path
                                        d="M31.1538 11H10.8462C10.3565 11 9.88695 11.1945 9.54073 11.5407C9.1945 11.8869 9 12.3565 9 12.8462V29.4615C9 29.9512 9.1945 30.4207 9.54073 30.767C9.88695 31.1132 10.3565 31.3077 10.8462 31.3077H31.1538C31.6435 31.3077 32.1131 31.1132 32.4593 30.767C32.8055 30.4207 33 29.9512 33 29.4615V12.8462C33 12.3565 32.8055 11.8869 32.4593 11.5407C32.1131 11.1945 31.6435 11 31.1538 11ZM31.1538 12.8462V24.7019L28.1458 21.695C27.9743 21.5235 27.7708 21.3875 27.5468 21.2947C27.3228 21.2019 27.0827 21.1541 26.8402 21.1541C26.5977 21.1541 26.3576 21.2019 26.1336 21.2947C25.9096 21.3875 25.7061 21.5235 25.5346 21.695L23.2269 24.0027L18.15 18.9258C17.8038 18.5798 17.3344 18.3855 16.845 18.3855C16.3556 18.3855 15.8862 18.5798 15.54 18.9258L10.8462 23.6196V12.8462H31.1538ZM10.8462 26.2308L16.8462 20.2308L26.0769 29.4615H10.8462V26.2308ZM31.1538 29.4615H28.6881L24.5342 25.3077L26.8419 23L31.1538 27.3131V29.4615ZM22.8462 17.9231C22.8462 17.6492 22.9274 17.3815 23.0795 17.1538C23.2316 16.9261 23.4479 16.7487 23.7009 16.6439C23.9539 16.5391 24.2323 16.5116 24.5009 16.5651C24.7695 16.6185 25.0162 16.7504 25.2098 16.944C25.4035 17.1376 25.5354 17.3844 25.5888 17.653C25.6422 17.9215 25.6148 18.1999 25.51 18.4529C25.4052 18.706 25.2277 18.9222 25 19.0743C24.7723 19.2265 24.5046 19.3077 24.2308 19.3077C23.8635 19.3077 23.5114 19.1618 23.2517 18.9021C22.992 18.6425 22.8462 18.2903 22.8462 17.9231Z"
                                        fill="#323238"/>
                                </svg>
                            </Tooltip>
                            <input id={`file_${result.id}`}
                                   type="file"
                                   multiple={widget.type.includes('array')}
                                   onChange={onFileChange}
                                   hidden={true}/>
                        </label>
                    )}
                    {widget['x-path'].upload_url && ['svg', 'png', 'webp', 'jpg', 'jpeg'].some(ext => widget['x-path'].extension.includes(ext)) && (
                        <Tooltip placement="top" title={t('Take picture')}>
                            <div onClick={() => setOpenTakePicture(!openTakePicture)}>
                                <svg width="42" height="42" viewBox="0 0 42 42" fill="none"
                                     xmlns="http://www.w3.org/2000/svg"
                                     style={{cursor: "pointer"}}>
                                    <path
                                        d="M29.75 30.1875H12.25C11.7859 30.1875 11.3408 30.0031 11.0126 29.6749C10.6844 29.3468 10.5 28.9016 10.5 28.4375V16.1875C10.5 15.7234 10.6844 15.2783 11.0126 14.9501C11.3408 14.6219 11.7859 14.4375 12.25 14.4375H15.75L17.5 11.8125H24.5L26.25 14.4375H29.75C30.2141 14.4375 30.6592 14.6219 30.9874 14.9501C31.3156 15.2783 31.5 15.7234 31.5 16.1875V28.4375C31.5 28.9016 31.3156 29.3468 30.9874 29.6749C30.6592 30.0031 30.2141 30.1875 29.75 30.1875Z"
                                        stroke="#323238" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                    <path
                                        d="M20.999 25.8125C23.1736 25.8125 24.9365 24.0496 24.9365 21.875C24.9365 19.7004 23.1736 17.9375 20.999 17.9375C18.8244 17.9375 17.0615 19.7004 17.0615 21.875C17.0615 24.0496 18.8244 25.8125 20.999 25.8125Z"
                                        stroke="#323238" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </Tooltip>
                    )}
                    {widget['x-path'].direct_link && (
                        <Tooltip placement="top" title={t('Paste link to file')}>
                            <div style={{position: "relative"}}>
                                <svg width="42" height="42" viewBox="0 0 42 42" fill="none"
                                     xmlns="http://www.w3.org/2000/svg"
                                     onClick={() => setOpenChangeLink(!openChangeLink)} style={{cursor: "pointer"}}>
                                    <path
                                        d="M19.3906 14.0818L20.943 12.1158C22.312 10.3821 24.8274 10.0864 26.5612 11.4555L27.8756 12.4934C29.6094 13.8625 29.9051 16.3778 28.536 18.1116L25.3551 22.1399C24.0161 23.8356 21.5725 24.1615 19.836 22.876L18.3022 21.7406"
                                        stroke="#323238" stroke-width="2" stroke-linecap="round"/>
                                    <path
                                        d="M22.1394 18.5247L21.1585 17.8555C19.4229 16.6715 17.067 17.032 15.7649 18.6809L12.519 22.7916C11.1499 24.5254 11.4456 27.0407 13.1794 28.4098L14.4944 29.4482C16.2282 30.8173 18.7436 30.5216 20.1126 28.7879L21.6521 26.8383"
                                        stroke="#323238" stroke-width="2" stroke-linecap="round"/>
                                </svg>
                                {openChangeLink && (
                                    <LinkEdit onLinkChange={onLinkChange} url={resultData?.measures?.[field]?.url}
                                              setOpenChangeLink={setOpenChangeLink}/>
                                )}
                            </div>
                        </Tooltip>
                    )}
                    {clipBoardFile && (
                        <Tooltip placement="top" title={t('Paste from clipboard')}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="40" height="40"
                                 viewBox="0 0 24 24" onClick={uploadClipBoardFile}>
                                <path
                                    d="M16,8.00100238 L10.5,8.00100238 C9.67157288,8.00100238 9,8.67257525 9,9.50100238 L9,18.5010024 C9,19.3294295 9.67157288,20.0010024 10.5,20.0010024 L17.5,20.0010024 C18.3284271,20.0010024 19,19.3294295 19,18.5010024 L19,11.0010024 L16.5,11.0010024 C16.2238576,11.0010024 16,10.7771448 16,10.5010024 L16,8.00100238 Z M20,10.5289799 L20,18.5010024 C20,19.8817143 18.8807119,21.0010024 17.5,21.0010024 L10.5,21.0010024 C9.11928813,21.0010024 8,19.8817143 8,18.5010024 L8,9.50100238 C8,8.1202905 9.11928813,7.00100238 10.5,7.00100238 L16.4720225,7.00100238 C16.6047688,6.99258291 16.7429463,7.03684187 16.8535534,7.14744899 L19.8535534,10.147449 C19.9641605,10.2580561 20.0084195,10.3962336 20,10.5289799 Z M17,10.0010024 L18.2928932,10.0010024 L17,8.70810916 L17,10.0010024 Z M11.5,13 C11.2238576,13 11,12.7761424 11,12.5 C11,12.2238576 11.2238576,12 11.5,12 L16.5,12 C16.7761424,12 17,12.2238576 17,12.5 C17,12.7761424 16.7761424,13 16.5,13 L11.5,13 Z M11.5,15 C11.2238576,15 11,14.7761424 11,14.5 C11,14.2238576 11.2238576,14 11.5,14 L16.5,14 C16.7761424,14 17,14.2238576 17,14.5 C17,14.7761424 16.7761424,15 16.5,15 L11.5,15 Z M11.5,17 C11.2238576,17 11,16.7761424 11,16.5 C11,16.2238576 11.2238576,16 11.5,16 L15.5,16 C15.7761424,16 16,16.2238576 16,16.5 C16,16.7761424 15.7761424,17 15.5,17 L11.5,17 Z M13.5,4 C13.2238576,4 13,3.77614237 13,3.5 C13,3.22385763 13.2238576,3 13.5,3 C14.8807119,3 16,4.11928813 16,5.5 L16,7 C16,7.27614237 15.7761424,7.5 15.5,7.5 C15.2238576,7.5 15,7.27614237 15,7 L15,5.5 C15,4.67157288 14.3284271,4 13.5,4 Z M6.5,3 C6.77614237,3 7,3.22385763 7,3.5 C7,3.77614237 6.77614237,4 6.5,4 C5.67157288,4 5,4.67157288 5,5.5 L5,14.5 C5,15.3284271 5.67157288,16 6.5,16 L8,16 C8.27614237,16 8.5,16.2238576 8.5,16.5 C8.5,16.7761424 8.27614237,17 8,17 L6.5,17 C5.11928813,17 4,15.8807119 4,14.5 L4,5.5 C4,4.11928813 5.11928813,3 6.5,3 Z M9,3.5 C9,3.77614237 8.77614237,4 8.5,4 C8.22385763,4 8,3.77614237 8,3.5 C8,2.67157288 8.67157288,2 9.5,2 L10.5,2 C11.3284271,2 12,2.67157288 12,3.5 C12,3.77614237 11.7761424,4 11.5,4 C11.2238576,4 11,3.77614237 11,3.5 C11,3.22385763 10.7761424,3 10.5,3 L9.5,3 C9.22385763,3 9,3.22385763 9,3.5 Z"/>
                            </svg>
                        </Tooltip>
                    )}
                </div>
                <div style={{paddingLeft: 10, display: "flex", flexDirection: "column", gap: 5}}>
                    <tabel>
                        {files.map((file, index) => (
                            <EditebleItem extensions={extensions}
                                          field={field}
                                          file={file}
                                          canBeLink={canBeLink}
                                          originalWidget={originalWidget}
                                          showDescription={showDescription}
                                          result={result}
                                          deleteFiles={deleteFiles}
                                          index={index}/>
                        ))}
                        {uploadedFiles.map((file, index) => (
                            <tr>
                                <td style={{verticalAlign: "middle", padding: "0 10px"}}>
                                    <Progress format={percent => percent} strokeLinecap="butt" type="dashboard"
                                              percent={file.progress} size={40}/>
                                </td>
                                <td style={{verticalAlign: "middle", padding: "10px"}}>
                                    {file?.name}
                                </td>
                                <td style={{verticalAlign: "middle", padding: "10px"}}>
                                    {prettyBytes(file?.size, {locale: i18n.language})}
                                </td>
                            </tr>
                        ))}
                    </tabel>

                </div>
            </FieldItem>

            {openTakePicture && (
                <TakePicture uploadFile={onPhotoChange} onClose={() => setOpenTakePicture(false)}/>
            )}
        </div>
    )
}
